import React, { useState } from 'react';
import './DelegationHistoryPanel.css';

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

const RoundStatusBadge = ({ status }) => {
  const map = {
    pending: { cls: 'dhp__badge--yellow', label: 'In Progress' },
    complete: { cls: 'dhp__badge--green', label: 'Complete' },
    cancelled: { cls: 'dhp__badge--gray', label: 'Cancelled' },
  };
  const { cls, label } = map[status] || { cls: 'dhp__badge--gray', label: status };
  return <span className={`dhp__badge ${cls}`}>{label}</span>;
};

const AssignmentStatusBadge = ({ status }) => {
  const map = {
    pending: { cls: 'dhp__badge--yellow', label: 'Pending' },
    submitted: { cls: 'dhp__badge--green', label: 'Submitted' },
    cancelled: { cls: 'dhp__badge--gray', label: 'Cancelled' },
  };
  const { cls, label } = map[status] || { cls: 'dhp__badge--gray', label: status };
  return <span className={`dhp__badge ${cls}`}>{label}</span>;
};

const AssignmentRow = ({ a }) => {
  const hasNotes = !!(a.approver_note || a.submitted_notes);
  const [expanded, setExpanded] = useState(false);

  return (
    <React.Fragment>
      <tr>
        <td className="dhp__td-group">{a.group_label}</td>
        <td>{a.assigned_to_email}</td>
        <td><AssignmentStatusBadge status={a.status} /></td>
        <td>{a.submitted_by_email || '—'}</td>
        <td>{formatDate(a.submitted_at)}</td>
        <td>
          {hasNotes ? (
            <button className="dhp__notes-toggle" onClick={() => setExpanded(e => !e)}>
              {expanded ? '▲ Hide' : '▼ Notes'}
            </button>
          ) : (
            <span className="dhp__no-notes">—</span>
          )}
        </td>
      </tr>
      {hasNotes && expanded && (
        <tr className="dhp__notes-row">
          <td colSpan={6}>
            {a.approver_note && (
              <div className="dhp__note dhp__note--approver">
                <span className="dhp__note-label">Approver note:</span> {a.approver_note}
              </div>
            )}
            {a.submitted_notes && (
              <div className="dhp__note dhp__note--delegate">
                <span className="dhp__note-label">Delegate comment:</span> {a.submitted_notes}
              </div>
            )}
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};

const DelegationHistoryPanel = ({ rounds }) => {
  if (!rounds || rounds.length === 0) {
    return null;
  }

  return (
    <div className="dhp__section">
      <h2 className="dhp__section-title">Contribution History</h2>
      <div className="dhp__rounds">
        {rounds.map((round, idx) => (
          <div key={round.id} className="dhp__round">
            <div className="dhp__round-header">
              <div className="dhp__round-meta">
                <span className="dhp__round-label">Round {rounds.length - idx}</span>
                <RoundStatusBadge status={round.status} />
                <span className="dhp__round-date">Initiated {formatDate(round.created_at)}</span>
                {round.completed_at && (
                  <span className="dhp__round-date">Completed {formatDate(round.completed_at)}</span>
                )}
              </div>
              <span className="dhp__initiated-by">by {round.initiated_by}</span>
            </div>

            {round.general_notes && (
              <p className="dhp__general-notes">{round.general_notes}</p>
            )}

            <table className="dhp__table">
              <thead>
                <tr>
                  <th>Group</th>
                  <th>Assigned To</th>
                  <th>Status</th>
                  <th>Submitted By</th>
                  <th>Submitted At</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {(round.assignments || []).map(a => (
                  <AssignmentRow key={a.id} a={a} />
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DelegationHistoryPanel;
